import _isNaN from "lodash/isNaN";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import TextInputWidget from './TextInputWidget';

const textParser = value => {
  const result = parseInt(value, 10);
  return !_isNaN(result) ? result : null;
};

const IntegerWidget = props => /*#__PURE__*/React.createElement(TextInputWidget, _extends({}, props, {
  keyboardType: "number-pad",
  mask: "9999999999",
  textParser: textParser
}));

export default IntegerWidget;